import { put, takeLatest, all } from "redux-saga/effects";
import axios from "axios";
import { OTP } from "../Constants";
import { OtpSuccess, OtpFailure } from "../Actions/OtpAction";

function* OtpRequest(actions) {
  try {
    const res = yield axios.post(`${process.env.REACT_APP_API_URL}api/admin/validate_otp`, {
      email: actions.payload.email,
      otp: actions.payload.otp,
      bankcode: actions.payload.bankcode,
    });
    if (res.status === 200) {
      yield put(OtpSuccess(res.data));
    } else yield put(OtpFailure(res));
  } catch (e) {
    yield put(OtpFailure(e));
  }
}

function* actionWatcher() {
  yield takeLatest(OTP, OtpRequest);
}

export default function* OtpSaga() {
  yield all([actionWatcher()]);
}
